export default "__VITE_ASSET__fcd51af8__"